import Navbar from "../../Navbar";
import { logEventos } from "../../../services/services";
import { useState, useEffect } from "react";
import { Box, Tabs, Tab } from "@mui/material";
import Formcargamenu from "./Formcargamenu";

function Cargarmenu() {
  const [tab, setTab] = useState(1);

  const handleChange = (event, newValue) => {
    setTab(newValue);
  };

  useEffect(() => {
    logEventos(
      "acceso al menú Cargar menu semanal",
      "Viandas",
      "Cargar menu semanal",
      localStorage.getItem("user")
    );
  }, []);

  //{/* //  {tab === 2 && resumenporsucursal y mostrar cantidad}  {/*//// // Menú rotativo  aca nose si validar que si ya hay un menu rotativo cargado desafilitar el tabs o la carga*/}  */}
  return (
    <>
      <Navbar />
      {/*   Cargarmenu */}

      <Box sx={{ width: "100%" }}>
        <Tabs value={tab} onChange={handleChange} centered>
          <Box sx={{ mt: 1.4 }}>
            {" "}
            <b>BON GOOD FOOD</b>{" "}
          </Box>
          <Tab label="Cargar Menú Diario" />
          <Tab label="Cargar Menú Rotativo" />
        </Tabs>

        <Box sx={{ mt: 3 }}>
          {tab === 1 && <Formcargamenu id_tipo={305} />} {/*//// Menú diario */}
          {tab === 2 && <Formcargamenu id_tipo={306} />} {/*//// Menú diario */}
        </Box>
      </Box>
    </>
  );
}

export default Cargarmenu;
